module.exports = __webpack_public_path__ + "media/images/icon__arrow-right@3x-d427e8f8203b959d111583fe7aadc142.png";